import axios from "axios";
import { getAxiosConfig } from "../core/common_functions";
import { GenericRequestResult } from "../core/common_types";
import { User } from "../models/user";

export const MeApi = {
    async setLogo(currentUser: User, logo: File): Promise<GenericRequestResult<string>> {            
        try {
            if (!logo) throw "Preview not available";

            let formData = new FormData();
            formData.append("logo", logo);

            let axiosConfig = getAxiosConfig(currentUser);
            axiosConfig.headers = {
                ...axiosConfig.headers,
                "Content-Type": "multipart/form-data"
            };
            
            let response = await axios.post(`${process.env.REACT_APP_API_URL}/profile/logo`, formData, axiosConfig);

            return response.data;
        } catch (e: any) {
            throw e;
        }
    },
    async removeLogo(currentUser: User): Promise<GenericRequestResult<any>> {            
        try {
            let axiosConfig = getAxiosConfig(currentUser);
            axiosConfig.headers = {
                ...axiosConfig.headers
            };
            
            let response = await axios.delete(`${process.env.REACT_APP_API_URL}/profile/logo`, axiosConfig);

            return response.data;
        } catch (e: any) {
            throw e;
        }
    }
}